module.exports = __webpack_public_path__ + "img/deal-no-deal.b536415.webp";